module.exports = __webpack_public_path__ + "img/heisseschokolade.95a3870d.jpg";